import axios from 'axios';
import {
	AppUserProfile,
	CreateAppUserDto,
	SocialCv,
	SocialCvItemType,
} from '../../types';

export const volunteerApi = {
	async fetchAppUser(id: string): Promise<AppUserProfile> {
		const { data } = await axios.get(`/volunteer/ngo-users/${id}`);
		return data;
	},

	async fetchAppUsers({
		ids,
		userQrCode,
		contactQrCode,
	}: {
		ids?: string[];
		userQrCode?: string;
		contactQrCode?: string;
	}): Promise<AppUserProfile[]> {
		const params: any = {};
		if (ids) {
			params.ids = ids;
		}
		if (userQrCode) {
			params.userQrCode = userQrCode;
		}
		if (contactQrCode) {
			params.contactQrCodeId = contactQrCode;
		}
		const { data } = await axios.get(`/volunteer/ngo-users`, {
			params,
		});
		return data;
	},

	async createAppUser(appUser?: CreateAppUserDto): Promise<AppUserProfile> {
		const { data } = await axios.post('/volunteer/ngo-users', appUser);
		return data;
	},

	async getJobAttendance(userId: string, ngoId?: number): Promise<any[]> {
		const { data } = await axios.get('/volunteer/ngo-job-attendances', {
			params: {
				userId,
				ngoId,
				fullList: true,
			},
		});
		return data;
	},

	async getJobAttendanceCount(
		userId: string,
		confirmedOnly?: boolean,
		ngoId?: number,
	): Promise<number> {
		const { data } = await axios.get('/volunteer/ngo-job-attendances/count', {
			params: {
				userId,
				confirmedOnly,
				ngoId,
			},
		});
		return data;
	},

	async getEventTicketItems(userId: string): Promise<any[]> {
		const { data } = await axios.get('/volunteer/ngo-event-ticket-items', {
			params: {
				userId,
				// ngoId, //it uses login user ngoId
				fullList: true,
			},
		});
		return data;
	},

	async getEventAttendance(userId: string, ngoId?: number): Promise<any[]> {
		const { data } = await axios.get('/volunteer/ngo-event-attendances', {
			params: {
				userId,
				ngoId,
				fullList: true,
			},
		});
		return data;
	},

	async getEventAttendanceCount(
		userId: string,
		checkedInOnly?: boolean,
		ngoId?: number,
	): Promise<number> {
		const { data } = await axios.get('/volunteer/ngo-event-attendances/count', {
			params: {
				userId,
				checkedInOnly,
				ngoId,
			},
		});
		return data;
	},

	async getSocialCvs({
		userId,
		excludeTypes,
		ngoId,
	}: {
		userId: string;
		excludeTypes?: SocialCvItemType[];
		ngoId?: number;
	}): Promise<SocialCv[]> {
		const { data } = await axios.get('/volunteer/ngo-social-cv', {
			params: {
				userId,
				excludeTypes,
				ngoId,
			},
		});
		return data;
	},

	async getServiceHours(
		userId: string,
		itemType: SocialCvItemType,
		ngoId?: number,
	): Promise<number> {
		const { data } = await axios.get('/volunteer/ngo-social-cv/service-hours', {
			params: {
				userId,
				itemType,
				ngoId,
			},
		});
		return data;
	},

	async getJobAttendanceStartDate(
		userId: string,
		ngoId?: number,
	): Promise<Date | null> {
		const { data } = await axios.get(
			'/volunteer/ngo-job-attendances/start-date',
			{
				params: {
					userId,
					ngoId,
				},
			},
		);

		return data ? new Date(data) : null;
	},
};
